// @ts-check

/**
 * @file Converts unknown thrown values into displayable messages.
 */

/**
 * Converts an unknown error value into a string.
 * @param {unknown} error Error value to format.
 * @returns {string} Message text for UI status output.
 */
export default function errorMessage(error) {
  if (!(error instanceof Error)) return String(error)

  const errorWithMetadata = /** @type {Error & {velocious?: {bugReportUrl?: unknown}}} */ (error)
  const bugReportUrl = errorWithMetadata.velocious && typeof errorWithMetadata.velocious.bugReportUrl === "string"
    ? errorWithMetadata.velocious.bugReportUrl
    : null

  if (!bugReportUrl) return error.message

  return `${error.message}\nBug report: ${bugReportUrl}`
}
